import React from 'react'
import { Link } from 'react-router-relative-link'
import { Icon } from 'src/components'
import { faLock } from '@fortawesome/free-solid-svg-icons'

export interface ReportCardProps {
  icon: string
  title: string
  bullets: string[]
  available: boolean
  /** Ruta relativa del reporte (navegación). */
  to?: string
  /** Acción alterna (ej. abrir modal) cuando no hay ruta. */
  onClick?: () => void
  /** Planes que habilitan el reporte, para el mensaje de la card bloqueada. */
  requiredPlans?: string[]
  viewLabel?: string
}

/** ['A'] → 'A' · ['A','B'] → 'A y B' · ['A','B','C'] → 'A, B y C' */
const formatPlanList = (plans: string[]): string =>
  plans.length <= 1
    ? plans[0] ?? ''
    : `${plans.slice(0, -1).join(', ')} y ${plans[plans.length - 1]}`

const ReportCard = ({
  icon,
  title,
  bullets,
  available,
  to,
  onClick,
  requiredPlans = [],
  viewLabel = 'Ver reporte',
}: ReportCardProps) => {
  const body = (
    <div className={`report-card${available ? '' : ' report-card--locked'}`}>
      <div className={'report-card__head'}>
        <img src={icon} alt={''} className={'report-card__icon'} />
        {!available && (
          <span className={'report-card__lock'}>
            <Icon icon={faLock} />
          </span>
        )}
      </div>

      <div className={'report-card__title'}>{title}</div>

      <ul className={'report-card__bullets'}>
        {bullets.map((bullet, i) => (
          <li key={i}>{bullet}</li>
        ))}
      </ul>

      <div className={'report-card__footer'}>
        {available ? (
          <span className={'report-card__btn'}>{viewLabel}</span>
        ) : (
          <span className={'report-card__locked-msg'}>
            Disponible en {requiredPlans.length > 1 ? 'los planes' : 'el plan'}{' '}
            {formatPlanList(requiredPlans)}
          </span>
        )}
      </div>
    </div>
  )

  if (!available) return body

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={'report-card-link'}>
        {body}
      </Link>
    )
  }

  return (
    <div className={'report-card-link'} role={'button'} onClick={onClick}>
      {body}
    </div>
  )
}

export default ReportCard
